import { useLenis } from "@/hooks/useLenis";
import { useLang } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { SearchBar } from "@/components/SearchBar";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Destinations } from "@/components/Destinations";
import { Packages } from "@/components/Packages";
import { Pricing } from "@/components/Pricing";
import { VehicleSelector } from "@/components/VehicleSelector";
import { WhyUs } from "@/components/WhyUs";
import { Reservation } from "@/components/Reservation";
import { Testimonials } from "@/components/Testimonials";
import { Contact, Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Home() {
  useLenis();
  const { lang } = useLang();
  const marqueeItems =
    lang === "en"
      ? ["Cancún Airport", "Hotel Xcaret", "Tulum", "Xel-Há", "Riviera Maya", "Private Transfers", "Xplor", "Mayakoba"]
      : ["Aeropuerto Cancún", "Hotel Xcaret", "Tulum", "Xel-Há", "Riviera Maya", "Traslados Privados", "Xplor", "Mayakoba"];

  return (
    <div className="App bg-sand">
      <Navbar />
      <main>
        <Hero />
        <SearchBar />
        <Marquee items={marqueeItems} />
        <Services />
        <Destinations />
        <Packages />
        <Pricing />
        <VehicleSelector />
        <WhyUs />
        <Reservation />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
